var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-flex',{attrs:{"xs12":"","sm6":"","md4":"","lg2":"","xl2":""}},[_c('div',{attrs:{"id":"projectBtn"}},[_c('project-card',{attrs:{"deletable":_vm.deletable,"card-data":_vm.projectData},on:{"refresh":_vm.refresh}},[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }